import { Divider, Flex, Segmented, Typography } from 'antd';
import React from 'react';
import { Observer } from 'src/interfaces/entities/observer';
import EditableTable from 'src/pages/indicators/EditIndicatorPage/_components/EditableTable';
import { IDashboardTree } from 'src/pages/indicators/EditIndicatorPage/types/dashboardTree';

interface IEditableTableProps {
	observers: Observer[];
	onChange?: (value: IDashboardTree) => void;
}

export default function EditableTables({
	observers,
	onChange,
}: IEditableTableProps) {
	const [ segmentedValue, setSegmentedValue, ] = React.useState<string>(
		observers[0]?.name?.toUpperCase()
	);
	const [ dashboardTree, setDashboardTree, ] = React.useState<IDashboardTree>(
		{}
	);
	const names = observers?.map(({ name, }) => name?.toUpperCase());

	React.useEffect(() => {
		onChange && onChange(dashboardTree);
	}, [ dashboardTree, ]);

	return (
		<Flex
			vertical
			style={{
				width: '100%',
				height: '100%',
				
			}}
		>
			<Flex gap={10} align={'center'}>
				<Typography.Text>Selecione o observador:</Typography.Text>
				<Segmented
					style={{ width: 'fit-content', }}
					options={names}
					onChange={(val) => {
						setSegmentedValue(val);
					}}
				/>
			</Flex>
			<Divider style={{ margin: 10, }} />
			<Flex>
				{observers.map((observer) => (
					<>
						{segmentedValue === observer?.name.toUpperCase() && (
							<EditableTable
								key={observer.observer_id}
								queryFields={observer?.sql_test_result}
								onChange={(row) => {
									const tree: IDashboardTree = {
										[observer?.short_name]: {
											occurence: {
												affectedRows: {
													result: row,
													count: row?.length,
												},
												affectedFields: {
													result: [],
													count: Object.keys(row)
														?.length,
												},
												meta: {
													executionMS: 0,
													totalRowsCount: 0,
													executionDate: '',
												},
											},
											observer: {
												observerId:
                                                    observer?.observer_id,
												name: observer?.name,
											},
											severity: {
												name: 'Lorem Ipsum',
											},
										},
									};
									const newTree: IDashboardTree = {};
									Object.entries(dashboardTree)
										?.filter((observer) => {
											return (
												observer[1].observer
													.observerId !==
                                                tree[observer[0]].observer.observerId
											);
										})
										?.map((observer) => {
											newTree[observer[0]] = observer[1];
										});

									setDashboardTree({ ...newTree, ...tree, });
								}}
							/>
						)}
					</>
				))}
			</Flex>
		</Flex>
	);
}
